export default __webpack_public_path__ + "static/media/avatar.c4b40de4.jpg";